import React, {FC} from "react"
import styled from "styled-components"
import flags from "country-flag-icons/react/3x2"

import Flex from "@irati/ui/src/Flex"
import {H3} from "@irati/ui/src/Typography"
import {StyledDeal} from "@irati-web/perks/src/components/Deal/styled/Deal"
import mainTheme from "@irati/ui/src/global/theme"

interface Props {}

const FlagWrapper = styled.div`
  width: 20px;
`

const Wrapper = styled(StyledDeal)`
  height: 363px;
  background: ${({theme}) => theme.colors.primary2};
  display: flex;
  align-items: center;
  justify-content: center;
`

const defaultFlag = "GB"

const countryKeyToFlagKeyMapper = {
  UK: "GB",
  IRE: "IE"
}

const CountryCard: FC<Props> = ({region}) => {
  const {name, id} = region
  const flagKey = countryKeyToFlagKeyMapper[id] || id
  const FlagComp = flags[flagKey] || defaultFlag

  return (
    <Wrapper>
      <Flex direction="column" alignItems="center">
        <FlagWrapper>
          <FlagComp title={name} />
        </FlagWrapper>
        <H3 color={mainTheme.colors.greys.white}>{name}</H3>
      </Flex>
    </Wrapper>
  )
}

export default CountryCard
